/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';
import * as CONST from '../utils/constants';

class Accordion {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Title click
        $(document).on('click', '.js-accordion-title', e => {
            this.handleAccordionBehavior(e);
        });

        $(document).on('keypress', '.js-accordion-title', e => {
            if (e.which === 13) {
                this.handleAccordionBehavior(e);
            }
        });
    }

    handleAccordionBehavior(e) {
        const accordion = $(e.currentTarget);
        let contentElem = null;

        // Toggle active class                    
        if ($(accordion).hasClass('active')) {
            $('.js-accordion-title, .js-accordion-content').removeClass('active');
            $('.js-accordion-content').height(0);
        } else {
            $('.js-accordion-title, .js-accordion-content').removeClass('active');
            $('.js-accordion-content').height(0);

            $(accordion).toggleClass('active');

            if ($(accordion).hasClass('accordion-title--h3')) {
                contentElem = $(accordion).prev('.js-accordion-content');
                // Toggle content visibility
                $(contentElem).stop().toggleClass('active');

                // If it is a non-anchored title - update the label
                if ($(accordion).hasClass('active')) {
                    $(accordion).text('Close Answer');
                } else {
                    $(accordion).text('View Full Answer');
                }
            }
            else {
                contentElem = $(accordion).next('.js-accordion-content');
                // Toggle content visibility
                $(contentElem).stop().toggleClass('active');
            }

            if ($(contentElem).hasClass('active')) {
                this.expandElem(contentElem);
            } else {
                this.collapseElem(contentElem);
            }
        }  
    }

    expandElem(e) {
        let targetHeight = $(e).children('.accordion-content-wrap').innerHeight();
        $(e).height(targetHeight);
        $(e).data('collapsed', 'false');
    }

    collapseElem(e) {
        $(e).height(0);
        $(e).data('collapsed', 'true');
    }
}

export default Accordion;

$(() => {
	const accordion = new Accordion();
	accordion.init();
});
